<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import CartBoard from "@/components/analytics/CartBoard.vue";
</script>

<template>
  <AgentLayout full-width>
    <CartBoard />
  </AgentLayout>
</template>
